<div class="cf-flex-column cf-flex-1">
  <label
    class="ac-form-field-label cf-flex"
    [ngClass]="{ 'ac-form-field-label-disabled': !property.Rules.EnableIf, 'ac-form-field-label-readonly': property.Rules.ReadOnlyIf }"
  >
    <span>{{ propertyType.NameId ? (propertyType.NameId | translate) : property.Key }}</span>
    <span *ngIf="property.Rules.RequiredIf" class="required-sign"> *</span>
    <span
      *ngIf="propertyType | tooltipTextId"
      class="ac-label-tooltip-container"
      [matTooltip]="propertyType | tooltipTextId | translate"
      [matTooltipPosition]="'above'"
      ><mat-icon class="ac-tooltip-icon help" svgIcon="help_outline"></mat-icon
    ></span>
  </label>
  <mat-form-field [attr.data-test]="property.Key" class="cf-flex textarea-without-overrides" appearance="outline" subscriptSizing="dynamic">
    <textarea
      matInput
      cdkTextareaAutosize
      #autosize="cdkTextareaAutosize"
      cdkAutosizeMinRows="3"
      cdkAutosizeMaxRows="5"
      type="text"
      [formControl]="propertyForm"
      [placeholder]="placeholder"
      floatLabel="auto"
      (focus)="focused = true"
      (blur)="focused = false"
    ></textarea>
    <mat-hint
      *ngIf="showCounter(property)"
      [ngClass]="{ 'mat-mdc-form-field-error': getCurrentLength(propertyForm) > getMaxLength(property) }"
      align="end"
      >{{ getCurrentLength(propertyForm) }}/{{ getMaxLength(property) }}</mat-hint
    >
  </mat-form-field>
  <div class="ac-form-field-message-error">
    <mat-error *ngIf="propertyForm.errors && propertyForm.errors['required']" translate> UI.Common.Validation.ValueRequired </mat-error>
    <mat-error
      *ngIf="propertyForm.errors && propertyForm.errors['minlength']"
      translate
      [translateParams]="{ minLength: getMinLength(propertyForm), currentLength: getCurrentLength(propertyForm) }"
    >
      UI.Common.Validation.ValueTooShort
    </mat-error>
    <mat-error *ngIf="propertyForm.errors && propertyForm.errors['pattern']" translate> UI.Validation.ValueInWrongFormat </mat-error>
  </div>
  <div *ngFor="let message of messages">
    <div
      [ngClass]="{
        'ac-form-field-message-error': message.Properties['Level']?.Value === 0,
        'ac-form-field-message-warning': message.Properties['Level']?.Value === 1,
        'ac-form-field-message-info': message.Properties['Level']?.Value === 2
      }"
    >
      {{ message.Properties['Text']?.Value || (message.Properties['TextId']?.Value | translate) }}
    </div>
  </div>
</div>
